import type { Product } from '#bv/data/products'
import { featuredProductIdForShop, getHubChildProductIds, isProductFamilyChildId } from '#bv/data/productFamilies'

function productMatchesQuery(p: Product, q: string): boolean {
  return (
    p.name.toLowerCase().includes(q) ||
    p.shortDescription.toLowerCase().includes(q) ||
    p.description.toLowerCase().includes(q) ||
    p.category.toLowerCase().includes(q)
  )
}

/**
 * Filter shop-visible products; hidden family tiers match queries by surfacing their hub card.
 */
export function filterShopProducts(shopVisible: Product[], fullCatalog: Product[], rawQuery: string): Product[] {
  const q = rawQuery.trim().toLowerCase()
  if (!q) return [...shopVisible]

  const visibleById = new Map(shopVisible.map((p) => [p.id, p]))
  const matchedIds = new Set<number>()

  for (const p of shopVisible) {
    if (productMatchesQuery(p, q)) matchedIds.add(p.id)
  }

  for (const p of fullCatalog) {
    if (!isProductFamilyChildId(p.id)) continue
    if (!productMatchesQuery(p, q)) continue
    const hubId = featuredProductIdForShop(p.id)
    if (visibleById.has(hubId)) matchedIds.add(hubId)
  }

  return shopVisible.filter((p) => matchedIds.has(p.id))
}

/** Navigate from site header search — clears other shop filters so results are not stale. */
export function navigateToShopSearch(
  navigate: (opts: {
    to: string
    search: { q: string; category: undefined; price: undefined; sort: undefined }
  }) => unknown,
  rawQuery: string,
) {
  const q = rawQuery.trim()
  if (!q) return
  void navigate({
    to: '/shop',
    search: { q, category: undefined, price: undefined, sort: undefined },
  })
}
